import { heroStats, tickerNews } from "@/mocks/homeData";

export default function Hero() {
  return (
    <section id="hero" className="relative overflow-hidden pt-[64px]">
      {/* texture backdrop */}
      <div className="pointer-events-none absolute inset-0 hairline opacity-70" />
      <div className="pointer-events-none absolute -right-40 -top-40 h-[480px] w-[480px] rounded-full bg-ember/10 blur-3xl" />
      <div className="pointer-events-none absolute -left-32 top-40 h-[360px] w-[360px] rounded-full bg-amber-400/20 blur-3xl" />

      <div className="shell-wrap relative grid gap-10 py-14 md:py-20 lg:grid-cols-[1.15fr_0.85fr] lg:items-center">
        {/* text-first column */}
        <div>
          <div className="rise rise-1 inline-flex items-center gap-2 rounded-full border border-ember/25 bg-ember/5 px-3.5 py-1.5 text-xs font-bold text-ember">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-ember opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-ember" />
            </span>
            合集大全 · 档案列表 · 专题整理 持续更新
          </div>

          <h1 className="title-serif rise rise-2 mt-6 text-4xl font-black leading-[1.15] tracking-tight md:text-[56px] md:leading-[1.1]">
            91黑料合集与大全
            <span className="block text-ember">一页总览 · 按需查阅</span>
          </h1>

          <p className="rise rise-3 mt-6 max-w-xl text-base leading-relaxed text-ink/70 md:text-lg">
            按<b className="font-bold text-ink">人物</b>、<b className="font-bold text-ink">事件</b>与
            <b className="font-bold text-ink">时间线</b>持续分类整理成档案与专题。不用东翻西找，
            热门瓜料与冷门旧闻都集中呈现，方便快速查阅。
          </p>

          {/* search */}
          <form
            className="rise rise-3 mt-8 flex max-w-xl items-center gap-2 rounded-full border border-ink/15 bg-paper p-1.5 shadow-none"
            onSubmit={(e) => e.preventDefault()}
          >
            <span className="pl-3 text-lg text-ink/40">
              <i className="ri-search-line" />
            </span>
            <input
              type="text"
              placeholder="搜人物 / 事件 / 专题关键词…"
              className="w-full bg-transparent text-sm outline-none placeholder:text-ink/40"
            />
            <button
              type="submit"
              className="whitespace-nowrap rounded-full bg-ink px-5 py-2.5 text-sm font-bold text-white transition-colors hover:bg-ember cursor-pointer"
            >
              查一查
            </button>
          </form>

          {/* stats */}
          <dl className="rise rise-4 mt-9 grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-ink/10 bg-ink/10 sm:grid-cols-4">
            {heroStats.map((s) => (
              <div key={s.label} className="bg-paper px-4 py-4">
                <dt className="text-xs text-ink/55">{s.label}</dt>
                <dd className="title-serif mt-1 text-xl font-black text-ember md:text-2xl">
                  {s.num}
                </dd>
              </div>
            ))}
          </dl>
        </div>

        {/* visual accompaniment */}
        <div className="rise rise-3 relative hidden lg:block">
          <div className="relative mx-auto max-w-sm">
            <div className="relative h-[440px] overflow-hidden rounded-2xl border border-ink/10">
              <img
                src="https://readdy.ai/api/search-image?query=editorial%20archive%20cover%20artwork%20with%20layered%20newspaper%20clippings%2C%20film%20photos%20and%20torn%20paper%20textures%20in%20warm%20cream%2C%20deep%20red%20and%20amber%20tones%2C%20stylized%20collage%20without%20readable%20text%2C%20soft%20shadow%2C%20magazine%20front%20page%20aesthetic%2C%20high%20detail&width=720&height=880&seq=hero-cover-x1&orientation=portrait"
                alt="91黑料合集大全总览封面"
                className="h-full w-full object-cover object-top"
              />
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-ink/40 via-transparent to-transparent" />
              <div className="absolute inset-x-4 bottom-4 rounded-xl bg-paper/90 p-4 backdrop-blur">
                <p className="text-xs font-bold tracking-wider text-ember uppercase">合集总览 一页看全</p>
                <p className="mt-1 text-sm font-medium text-ink/80">人物 · 事件 · 时间线 · 专题</p>
              </div>
            </div>

            {/* floating chips */}
            <div className="absolute -left-10 top-10 rounded-xl border border-ink/10 bg-paper px-4 py-3 shadow-sm">
              <p className="text-xs text-ink/50">今日新归档</p>
              <p className="title-serif text-lg font-black text-ink">2,451 条事件</p>
            </div>
            <div className="absolute -right-6 bottom-24 rounded-xl border border-ember/20 bg-ember px-4 py-3 text-white shadow-sm">
              <p className="text-xs text-white/70">冷门旧闻专区</p>
              <p className="title-serif text-lg font-black">随时考古</p>
            </div>
          </div>
        </div>
      </div>

      {/* ticker */}
      <div className="border-y border-ink/10 bg-paper/80 py-2.5">
        <div className="shell-wrap flex items-center gap-3 overflow-hidden">
          <span className="flex shrink-0 items-center gap-1.5 whitespace-nowrap text-xs font-black text-ember">
            <i className="ri-fire-fill" /> 快讯
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="marquee-track flex w-max items-center gap-8">
              {[...tickerNews, ...tickerNews].map((t, i) => (
                <span key={i} className="flex items-center gap-8 whitespace-nowrap text-sm text-ink/65">
                  {t}
                  <i className="ri-arrow-right-line text-ember" />
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}